var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "gp2-qtl-region-plot" },
    [
      _vm.showLegend
        ? _c("div", { staticClass: "gp2-qtl-region-plot-legend" }, [
            _c("span", { staticClass: "vks-legend-item" }, [
              _c("span", {
                staticClass: "plot-legend-dot",
                style: { backgroundColor: _vm.positiveColor },
              }),
              _c("span", [_vm._v("Positive effect (β > 0)")]),
            ]),
            _c("span", { staticClass: "vks-legend-item" }, [
              _c("span", {
                staticClass: "plot-legend-dot",
                style: { backgroundColor: _vm.negativeColor },
              }),
              _c("span", [_vm._v("Negative effect (β < 0)")]),
            ]),
            _c("span", { staticClass: "vks-legend-item" }, [
              _c("span", {
                staticClass: "plot-legend-dot",
                style: { backgroundColor: _vm.neutralColor },
              }),
              _c("span", [_vm._v("No effect direction")]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { ref: "canvasWrap", staticClass: "gp2-qtl-region-plot-canvas-wrap" },
        [
          _c("canvas", {
            ref: "canvas",
            staticClass: "gp2-qtl-region-plot-canvas",
            class: {
              "is-pannable": _vm.canPan,
              "is-x-axis-hover": _vm.xAxisBandHover,
              "is-dot-hover": _vm.dotHover,
            },
            on: {
              mousedown: _vm.onMouseDown,
              mousemove: _vm.onMouseMove,
              mouseout: _vm.onMouseOut,
              mouseup: _vm.onMouseUp,
              click: _vm.onCanvasClick,
            },
          }),
          _vm.showViewRegionHandle && _vm.viewRegionHandleStyle
            ? _c(
                "div",
                {
                  staticClass: "gp2-view-region-handle",
                  class: {
                    "is-dragging": _vm.isDraggingViewHandle,
                    "is-hovered": _vm.isHoveringViewHandle,
                  },
                  style: _vm.viewRegionHandleStyle,
                  attrs: {
                    role: "slider",
                    tabindex: "0",
                    "aria-label": `Viewing region (${_vm.viewingRegionWidthLabel}) handle — drag to move viewing region`,
                    title: _vm.viewRegionHandleTitle,
                  },
                  on: {
                    mouseenter: function ($event) {
                      _vm.isHoveringViewHandle = true
                    },
                    mouseleave: function ($event) {
                      _vm.isHoveringViewHandle = false
                    },
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onViewHandleMouseDown.apply(null, arguments)
                    },
                    keydown: _vm.onViewHandleKeyDown,
                  },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm.showViewRegionBridge && _vm.viewRegionConnectorStyle
            ? _c("div", {
                staticClass: "gp2-view-region-connector",
                class: {
                  "is-active":
                    _vm.isHoveringViewHandle || _vm.isDraggingViewHandle,
                },
                style: _vm.viewRegionConnectorStyle,
                attrs: { "aria-hidden": "true" },
              })
            : _vm._e(),
          _vm.showViewRegionBridge && _vm.viewRegionBridgeStyle
            ? _c(
                "div",
                {
                  staticClass: "gp2-view-region-bridge",
                  class: {
                    "is-active":
                      _vm.isHoveringViewHandle || _vm.isDraggingViewHandle,
                  },
                  style: _vm.viewRegionBridgeStyle,
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("span", { staticClass: "gp2-view-region-bridge-top" }),
                  _c("span", {
                    staticClass:
                      "gp2-view-region-bridge-edge gp2-view-region-bridge-edge--left",
                  }),
                  _c("span", {
                    staticClass:
                      "gp2-view-region-bridge-edge gp2-view-region-bridge-edge--right",
                  }),
                  _vm._l(_vm.bridgeExonMarks, function (mark) {
                    return _c("span", {
                      key: mark.key,
                      staticClass: "gp2-view-region-bridge-exon",
                      style: {
                        left: `${mark.left}%`,
                        width: `${mark.width}%`,
                        backgroundColor: mark.color,
                      },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm.showViewRegionBridge && _vm.bridgeViewGenes.length
        ? _c(
            "div",
            {
              staticClass: "gp2-view-region-bridge-genes",
              attrs: { "aria-label": "Genes overlapping the viewing region" },
            },
            _vm._l(_vm.bridgeViewGenes, function (gene) {
              return _c(
                "span",
                {
                  key: gene.name,
                  staticClass: "gp2-view-region-bridge-gene",
                  style: { color: gene.color },
                },
                [_vm._v(" " + _vm._s(gene.name) + " ")]
              )
            }),
            0
          )
        : _vm._e(),
      _c("VariantSifterVariantDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          "variant-id": _vm.dotMenuVariantId,
          "is-starred": _vm.dotMenuIsStarred,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: {
          "set-reference": _vm.onDotMenuSetReference,
          "toggle-star": _vm.onDotMenuToggleStar,
        },
      }),
      _c("div", {
        ref: "tooltip",
        staticClass: "gp2-qtl-region-plot-tooltip hidden",
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "gp2-view-region-handle-bracket",
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("span", {
          staticClass:
            "gp2-view-region-handle-edge gp2-view-region-handle-edge--left",
        }),
        _c("span", { staticClass: "gp2-view-region-handle-bar" }),
        _c("span", {
          staticClass:
            "gp2-view-region-handle-edge gp2-view-region-handle-edge--right",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }